/**
 * Created by Jie Gao on 2018-01-09.
 */
import * as PIXI from "pixi.js";
import {Asset, AssetQualityLevel, IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/core/resource/asset/Asset";
import {BitmapFontAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/BitmapFontAsset";
import {TextureAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/TextureAsset";

export class WixxGameAssets {

    public static INTRO_BACKGROUND:string = "resources/images/intro/splashBackground.jpg";
    public static INTRO_LOGO:string = "resources/images/intro/splash-title.jpg";
    public static INTRO_BACKGROUND_PORTRAIT:string = "resources/images/intro/backgound_portrait.jpg";
    public static INTRO_FEATURE_1_ANIMATE:string = "resources/images/intro/M1/M1-boost/M1-boost-";
    public static INTRO_FEATURE_0_ANIMATE:string = "resources/images/intro/M2/M2-boost/M2-boost-";
    public static INTRO_FEATURE_2_ANIMATE:string = "resources/images/intro/M3/M3-boost/M3-boost-";
    public static INTRO_FEATURE_0_TEXT:string = "resources/images/intro/splash-textTopaz.jpg";
    public static INTRO_FEATURE_1_TEXT:string = "resources/images/intro/splash-textRuby.jpg";
    public static INTRO_FEATURE_2_TEXT:string = "resources/images/intro/splash-textSapphire.jpg";
    public static INTRO_FEATURE_SPOTLIGHT:string = "resources/images/intro/splash-spotlight.jpg";

    public static RESOURCES_GROUPS:IResourcesGroupConfig = {
        intro : [
            {
                name : "fonts",
                assets : [
                    new BitmapFontAsset("NumbersOpenSans800", "fonts/bitmapfonts/NumbersOpenSans800.fnt"),
                ]
            },
            {
                name : "intro",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("particle", "images/background/particle.png"),
                    new TextureAsset("introJpeg0", "sheets/intro/introJpeg0.json"),
                    new TextureAsset("introJpeg1", "sheets/intro/introJpeg1.json"),
                    new TextureAsset("introJpeg2", "sheets/intro/introJpeg2.json"),
                    new TextureAsset("introJpeg3", "sheets/intro/introJpeg3.json")
                ],
                animations : {
                    "stackedReel4Flow" : "EnergyFlow/EnergyFlow-"
                }
            },
            {
                name : "introSymbolsSmart",
                assets : [
                    new TextureAsset("introSymbolsSmart0", "sheets/introSymbols/introSymbolsSmart0.json")
                ],
                animations : {
                    "x5" : "x5/x5/x5-",
                    "x5_spin" : "x5/x5_spin"
                }
            },
            {
                name : "introSymbolsYellow",
                assets : [
                    new TextureAsset("introSymbolsYellow0", "sheets/introSymbolsYellow/introSymbolsYellow0.json"),
                    new TextureAsset("introSymbolsYellow1", "sheets/introSymbolsYellow/introSymbolsYellow1.json")
                ],
                animations : {
                    "M2_idle" : "M2/M2-idle/M2-idle-",
                    "M2_boosted" : "M2/M2-boost/M2-boost-"
                }
            },
            {
                name : "introSymbolsBlue",
                assets : [
                    new TextureAsset("introSymbolsBlue0", "sheets/introSymbolsBlue/introSymbolsBlue0.json"),
                    new TextureAsset("introSymbolsBlue1", "sheets/introSymbolsBlue/introSymbolsBlue1.json")
                ],
                animations : {
                    "M3_idle" : "M3/M3-idle/M3-idle-",
                    "M3_boosted" : "M3/M3-boost/M3-boost-"
                }
            },
            {
                name : "introSymbolsRed",
                assets : [
                    new TextureAsset("introSymbolsRed0", "sheets/introSymbolsRed/introSymbolsRed0.json"),
                    new TextureAsset("introSymbolsRed1", "sheets/introSymbolsRed/introSymbolsRed1.json")
                ],
                animations : {
                    "M1_idle" : "M1/M1-idle/M1-idle-",
                    "M1_boosted" : "M1/M1-boost/M1-boost-"
                }
            }
        ],
        main : [
            {
                name : "main",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("mainBackground", "images/background/background.jpg"),
                    new TextureAsset("background_blue", "images/background/backgroundBLUE.jpg"),
                    new TextureAsset("background_red", "images/background/backgroundRED.jpg"),
                    new TextureAsset("background_yellow", "images/background/backgroundYELLOW.jpg"),
                    new TextureAsset("bigWin_neon_foreground", "images/bigwin/BigWinFX.jpg"),
                    new TextureAsset("mainJpeg0", "sheets/main/mainJpeg0.json"),
                    new TextureAsset("main0", "sheets/main/main0.json"),
                ],
                animations : {
                    "background_portrait_ex" : "background/thin_bg_purple",
                    "background_portrait_ex_yellow" : "background/thin_bg_yellow",
                    "background_portrait_ex_red" : "background/thin_bg_red",
                    "background_portrait_ex_blue" : "background/thin_bg_blue",
                    "background_portrait_border" : "background/border_purple",
                    "background_portrait_border_yellow" : "background/border_yellow",
                    "background_portrait_border_red" : "background/border_red",
                    "background_portrait_border_blue" : "background/border_blue",
                    "logo_on_background" : "WixxLogo",
                    "top_gradient" : "background/topGradient",
                    "foreground_respin_text_0" : "respin/respinPart1",
                    "foreground_respin_text_1" : "respin/respinPart2",
                    "foreground_respin_text_2" : "respin/respinPart3",
                    "foreground_respin_text_3" : "respin/respinPart4",
                    "bigWin_bigWin_left" : "bigwin/wixxed-left",
                    "bigWin_bigWin_right" : "bigwin/wixxed-right",
                    "bigWin_megaWin_left" : "bigwin/xxstatic-left",
                    "bigWin_megaWin_right" : "bigwin/xxstatic-right",
                    "bigWin_superMegaWin_left" : "bigwin/xxcess-left",
                    "bigWin_superMegaWin_right" : "bigwin/xxcess-right",
                    "bigWin_extremeWin_center" : "bigwin/xxtreme-center",
                    "bigWin_extremeWin_left" : "bigwin/xxtreme-left",
                    "bigWin_extremeWin_right" : "bigwin/xxtreme-right",
                    "81ways_base" : "wayswon/81ww-base",
                    "81ways_blue" : "wayswon/81ww-blue",
                    "81ways_red" : "wayswon/81ww-red",
                    "81ways_yellow" : "wayswon/81ww-yellow",
                    "waywon_base" : "wayswon/waywon-base",
                    "waywon_blue" : "wayswon/waywon-blue",
                    "waywon_red" : "wayswon/waywon-red",
                    "waywon_yellow" : "wayswon/waywon-yellow",
                    "wayswon_base" : "wayswon/wayswon-base",
                    "wayswon_blue" : "wayswon/wayswon-blue",
                    "wayswon_red" : "wayswon/wayswon-red",
                    "wayswon_yellow" : "wayswon/wayswon-yellow",
                }
            },
            {
                name : "mainSmart",
                assets : [
                    new TextureAsset("mainSmart0", "sheets/main/mainSmart0.json"),
                    new TextureAsset("mainSmart1", "sheets/main/mainSmart1.json"),
                    new TextureAsset("mainJpegSmart0", "sheets/main/mainJpegSmart0.json"),
                    new TextureAsset("mainJpegSmart1", "sheets/main/mainJpegSmart1.json")
                ],
                animations : {
                    "foreground_respin" : "WhiteSaber/WhiteSaber-",
                    "winBurst" : "WinBurst/WinBurst-",
                    "nearWinReelDivider" : "ReelSaber/ReelSaber-",
                    "M1_spin" : "M1/M1_spin",
                    "M1_boosted_spin" : "M1/M1_boost_spin",
                    "L4_spin" : "L4/L4_spin",
                    "M3_spin" : "M3/M3_spin",
                    "M3_boosted_spin" : "M3/M3_boost_spin",
                    "M2_spin" : "M2/M2_spin",
                    "M2_boosted_spin" : "M2/M2_boost_spin"
                }
            },
            {
                name : "symbolsSmartRed",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("symbolsSmartRed0", "sheets/symbolsSmartRed/symbolsSmartRed0.json")
                ],
                animations : {
                    "M1_win" : "M1/M1-win/M1-win-"
                }
            },
            {
                name : "symbolsSmartBlue",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("symbolsSmartBlue0", "sheets/symbolsSmartBlue/symbolsSmartBlue0.json"),
                    new TextureAsset("symbolsSmartBlue1", "sheets/symbolsSmartBlue/symbolsSmartBlue1.json")
                ],
                animations : {
                    "L4_idle" : "L4/L4-idle/L4-idle-",
                    "L4_win" : "L4/L4-win/L4-win-",
                    "M3_win" : "M3/M3-win/M3-win-"
                }
            },
            {
                name : "symbolsSmartYellow",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("symbolsSmartYellow0", "sheets/symbolsSmartYellow/symbolsSmartYellow0.json"),
                    new TextureAsset("symbolsSmartYellow1", "sheets/symbolsSmartYellow/symbolsSmartYellow1.json")
                ],
                animations : {
                    "M2_win" : "M2/M2-win/M2-win-"
                }
            },
            {
                name : "symbolsSmart",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("symbolsSmart0", "sheets/symbols/symbolsSmart0.json"),
                    new TextureAsset("symbolsSmart1", "sheets/symbols/symbolsSmart1.json"),
                    new TextureAsset("symbolsSmart2", "sheets/symbols/symbolsSmart2.json")
                ],
                animations : {
                    "L1_idle" : "L1/L1-idle/L1-idle-",
                    "L1_spin" : "L1/L1_spin",
                    "L1_win" : "L1/L1-win/L1-win-",
                    "L2_idle" : "L2/L2-idle/L2-idle-",
                    "L2_spin" : "L2/L2_spin",
                    "L2_win" : "L2/L2-win/L2-win-",
                    "L3_idle" : "L3/L3-idle/L3-idle-",
                    "L3_spin" : "L3/L3_spin",
                    "L3_win" : "L3/L3-win/L3-win-",
                    "W_idle" : "W/W-idle/W-idle-",
                    "W_spin" : "W/W_spin",
                    "W_win" : "W/W-win/W-win-",
                    "W_attention" : "W/WildAttention/W-idle-000_"
                }
            }
        ]
    };
}